import { LoadingButton } from '@mui/lab';
import { Box, Button, Grid, TextField } from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { AuthStore } from '../../../../store/UserStore';
import { base_url } from '../../../../utils/GlobalVariables';
import { CustomDescrypt } from '../../../../utils/MyEncryption';
import SaveIcon from '@mui/icons-material/Save';
import { AttachFile } from '@mui/icons-material';
import profil from '../../../../assets/images/profil.jpg'

const Form = ({ edit = null, setEdit }) => {
    const navigate = useNavigate();
    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = encryptUserJson.state.user === null ? "" : JSON.parse(CustomDescrypt(encryptUserJson.state.user));
    const [loading, setLoading] = useState(false);
    const logOut = AuthStore((state) => state.logOut);
    const [formData, setFormData] = useState({
        username_lama:"",
        username: "",
        password: "",
        nama: "",
        nip: "",
        foto: null
    });
    const [image, setImage] = useState(edit === null ? null : base_url + '/uploads/images/verifikator/' + edit.username + '.png')

    useEffect(() => {
        edit !== null && setFormData({
            ...formData,
            _method: 'PUT',
            username_lama: edit.username,
            username: edit.username,
            password: edit.password,
            nama: edit.nama,
            nip: edit.nip,
            foto: base_url + '/uploads/images/verifikator/' + edit.username + '.png'
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onChangeInput = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        })
        console.log(formData);
    }

    const submitForm = () => {
        const isValid = checkForm(formData);
        if (!isValid) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Isi semua Input'
            })
            return;
        }

        if (formData.foto === null) {
            const reader = new FileReader();
            reader.onload = () => {
                setImage(reader.result);
            };
            reader.readAsDataURL(profil);

            setFormData({
                ...formData,
                foto: image
            })
        }

        setLoading(true);
        axios.post(
            base_url + '/admin/verifikator/insert',
            formData,
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`,
                    'content-type': 'multipart/form-data'
                }
            })
            .then((response) => {
                setLoading(false);

                Swal.fire({
                    icon: 'success',
                    title: 'Berhasil',
                    text: response.data.msg
                })

                setFormData({
                    username_lama: '',
                    username: "",
                    password: "",
                    nama: "",
                    nip: "",
                    id_opd: "",
                    status: "",
                    foto: null
                });
                navigate(-1);
            })
            .catch((error) => {
                console.log(error);
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops..',
                        text: error.response.status + ' ' + error.response.statusText
                    })
                }
                setLoading(false)
            })
    }

    const updateData = () => {
        console.log(formData);
        setLoading(true);
        axios.post(
            base_url + '/admin/verifikator/update',
            formData,
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`,
                    'content-type': 'multipart/form-data'
                }
            })
            .then((response) => {
                console.log(response);
                setLoading(false);

                Swal.fire({
                    icon: 'success',
                    title: 'Berhasil',
                    text: response.data.msg
                })

                setFormData({
                    username_lama: "",
                    username: "",
                    password: "",
                    nama: "",
                    nip: "",
                    id_opd: "",
                    status: "",
                    foto: null
                });
                setEdit(null);
            })
            .catch((error) => {
                console.log(error);
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops..',
                        text: error.response.status + ' ' + error.response.statusText
                    })
                }
                setLoading(false)
            })
    }

    function checkForm(obj) {
        for (var key in obj) {
            if (obj[key] === "" || obj[key] === null) {
                if (key !== 'username_lama') {
                    return false;
                }
            }
        }
        return true;
    }

    const loadData = (event) => {
        const file = event.target.files[0];
        if (file === undefined || file === "") {
            setFormData({
                ...formData,
                [event.target.name]: null
            })
        }
        else {
            setFormData({
                ...formData,
                [event.target.name]: file
            })
            const reader = new FileReader();
            reader.onload = () => {
                setImage(reader.result);
            };
            reader.readAsDataURL(file);
        }
    }

    return (
        <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={4} justifyContent='center'>
                <Grid item xs={12} md={6} sx={{ textAlign: "center" }}>
                    <TextField
                        fullWidth
                        name='nip'
                        id="standard-basic"
                        label="NIP"
                        variant="standard"
                        margin="normal"
                        value={formData.nip}
                        onChange={(e) => onChangeInput(e)}
                        error={formData.nip === "" ? true : false}
                    />
                </Grid>
                <Grid item xs={12} md={6} sx={{ textAlign: "center" }}>
                    <TextField
                        fullWidth
                        name='nama'
                        id="standard-basic"
                        label="Nama"
                        variant="standard"
                        margin="normal"
                        value={formData.nama}
                        onChange={(e) => onChangeInput(e)}
                        error={formData.nama === "" ? true : false}
                    />
                </Grid>
                <Grid item xs={12} md={6} sx={{ textAlign: "center" }}>
                    <TextField
                        fullWidth
                        name='username'
                        id="standard-basic"
                        label="Username"
                        variant="standard"
                        margin="normal"
                        value={formData.username}
                        onChange={(e) => onChangeInput(e)}
                        error={formData.username === "" ? true : false}
                    />
                </Grid>
                <Grid item xs={12} md={6} sx={{ textAlign: "center" }}>
                    <TextField
                        fullWidth
                        name='password'
                        id="standard-basic"
                        label="Password"
                        variant="standard"
                        margin="normal"
                        value={formData.password}
                        onChange={(e) => onChangeInput(e)}
                        error={formData.password === "" ? true : false}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={2} pt={2} justifyContent="center">
                <Grid item>
                    <Button
                        variant="outlined"
                        component="label"
                        startIcon={<AttachFile />}
                        color={formData.foto === null ? 'error' : 'primary'}
                    >
                        Foto
                        <input
                            hidden
                            name='foto'
                            accept="image/jpeg, image/jpg"
                            multiple type="file"
                            onChange={loadData}
                        />
                    </Button>
                </Grid>
            </Grid>

            {
                image !== null &&
                (
                    <Grid container spacing={2} py={2} justifyContent="center">
                        <Grid item xs={12} lg={4}>
                            <img style={{ width: "100%" }} src={image} alt="cropped" />
                        </Grid>
                    </Grid>
                )
            }

            <Grid container spacing={2} py={2} justifyContent="flex-end">
                <Grid item >
                    <LoadingButton
                        onClick={edit === null ? submitForm : updateData}
                        loading={loading}
                        variant="contained"
                        margin="normal"
                        loadingPosition="start"
                        startIcon={<SaveIcon />}
                    >
                        {edit === null ? "Simpan" : "Update"}
                    </LoadingButton>
                </Grid>
            </Grid>
        </Box>
    )
}

export default Form